// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"94":"06815f95","191":"cb7add6a","518":"ee774890","544":"8c61827e","960":"ce384897"}[chunkId] + ".css";
};